import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Download, ExternalLink } from "lucide-react";

export default function Help() {
  const [md, setMd] = useState("");
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetch("/user-guide.md", { cache: "no-cache" })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then(setMd)
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-500">Documentation</p>
          <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1">
            Help &amp; User Guide
          </h1>
          <p className="text-sm text-slate-600 mt-1 max-w-2xl">
            A stage-by-stage walkthrough of the full ClaimWerks deal lifecycle — from lead intake
            to court filing to disbursement.
          </p>
        </div>
        <div className="flex gap-2">
          <a href="/user-guide.md" download="ClaimWerks-User-Guide.md">
            <Button variant="outline" data-testid="help-download-btn">
              <Download className="h-4 w-4 mr-1.5" /> Download .md
            </Button>
          </a>
          <a href="/user-guide.md" target="_blank" rel="noreferrer">
            <Button variant="outline" data-testid="help-open-raw-btn">
              <ExternalLink className="h-4 w-4 mr-1.5" /> Open raw
            </Button>
          </a>
        </div>
      </div>

      <Card className="p-6 md:p-10 border-slate-200" data-testid="help-guide-card">
        {err && (
          <p className="text-sm text-red-700">
            Could not load the guide ({err}).
          </p>
        )}
        {!err && !md && (
          <p className="text-sm text-slate-500 flex items-center gap-2">
            <BookOpen className="h-4 w-4" /> Loading the guide…
          </p>
        )}
        {md && (
          <article className="cw-md" data-testid="help-guide-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
          </article>
        )}
      </Card>
    </div>
  );
}
